import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as JspUtil from '../common/JspUtil';
import * as actions from './actionCreators';
import submitHiddenForm from '../common/submitHiddenForm';
import { useJspVariables, useAppContext, useDebugRender } from '../hooks';
import { Dropdown, PageContainer } from '../components';
import Button from '@mui/material/Button';

const PageLogout = () => {
    useDebugRender('PageLogout');
    const dispatch = useDispatch();
    const { jspVariables, panelStyle } = useJspVariables();
    const { getLoginApp } = useAppContext(jspVariables);

    const [selectedUser, setSelectedUser] = useState('');
    const [userOptions, setUserOptions] = useState([]);

    const redirectUrl = JspUtil.isValueAvailable(window.jspRedirectUrl) ? window.jspRedirectUrl : '';
    const appKey = JspUtil.isValueAvailable(window.jspLoginApp) ? window.jspLoginApp : '';
    const userName = JspUtil.isValueAvailable(window.jspUserId) ? window.jspUserId : '';

    useEffect(() => {
        const userNames = [];
        if (JspUtil.isValueAvailable(window.jspLinkCandidates)) {
            const linkstr = window.jspLinkCandidates;
            const loginAppKey = getLoginApp();
            if (linkstr && loginAppKey) {
                const links = JSON.parse(linkstr);
                if (links.length > 0) {
                    links.forEach(function (linkInfo) {
                        let name = linkInfo.display;
                        if (linkInfo.showComp === 'Y' && linkInfo.cname) {
                            name = name + ' - ' + linkInfo.cname;
                        }
                        userNames.push({ l: name, v: linkInfo.uname });
                    });
                }
            }
        }
        setUserOptions(userNames);
    }, []);

    const onContinueClick = () => {
        submitHiddenForm('/appUserLogin', {
            redirectUrl,
            loginUserId: selectedUser,
            loginApp: appKey,
        });
    };

    const onLogoutClick = () => {
        dispatch({ type: actions.USER_INPUT_APP_KEY_CHANGE, data: '' });
        dispatch(actions.logoutUserToken(userName, false, false));
    };

    return (
        <PageContainer id="pageLogout" dataAutomationId="page_logout">
            <Box style={panelStyle}>
                <Box>
                    <Typography fontWeight={500}>{JspUtil.getLabelFromJspVariables('question_switch_user')}</Typography>
                    <Dropdown selectedValue={selectedUser}
                        labelProperty="l"
                        valueProperty="v"
                        options={userOptions}
                        id="logout_user_select"
                        name="logoutuser"
                        dataAutomationId="logout_user_select"
                        updateValue={val => setSelectedUser(val)} />
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button variant="contained" fullWidth
                        disabled={!selectedUser}
                        onClick={onContinueClick}
                        data-automation-id="logout_user_go_back_btn">
                        Yes, Go back
                    </Button>
                    <Button variant="contained" fullWidth
                        onClick={onLogoutClick}
                        data-automation-id="logout_completely_btn">
                        No, Logout Completely
                    </Button>
                </Box>
            </Box>
        </PageContainer>
    );
};

export default PageLogout;
